import { DirectivesModule } from 'app/shared/directives';
import {NgModule} from "@angular/core";
import {CommonModule} from "@angular/common";
import {FormsModule, ReactiveFormsModule} from "@angular/forms";

import {HeaderModule} from "./header/header.module";
import {FooterComponent} from "./footer/footer.component";
import {NavigationModule} from "./navigation/navigation.module";
import {RibbonComponent} from "./ribbon/ribbon.component";
import {ShortcutComponent} from "./shortcut/shortcut.component";
import {LayoutSwitcherComponent} from "./layout-switcher.component";
import { MainLayoutComponent } from './app-layouts/main-layout.component';
import { EmptyLayoutComponent } from './app-layouts/empty-layout.component';
import {RouterModule} from "@angular/router";
import { AuthLayoutComponent } from './app-layouts/auth-layout.component';
import {TooltipModule, BsDropdownModule, BsDatepickerModule} from "ngx-bootstrap";
import { RouteBreadcrumbsComponent } from './ribbon/route-breadcrumbs.component';
import {UtilsModule} from "../utils/utils.module";
import { PipesModule } from '../pipes';
import { SharedComponentsModule } from '../components/shared-components.module';
import { AppTypeaheadModule } from '../typeahead';
import { CampaignGridAssetsComponent } from '../campaign-modal-component/assets/grid.component';
import { CampaignGridTacticsComponent } from '../campaign-modal-component/tactics/grid.component';
import { CampaignImagePreviewModalComponent } from '../campaign-modal-component/image-previwer/image-preview.modal.component';
import { CampaignModalComponent } from '../campaign-modal-component/campaign-modal-component.component';
import { CreateCampaignModalComponent } from '../create-campaign-modal/create-campaign-modal.component';
import { DeliveryInformationComponent } from '../delivery-information/delivery-information.component';
import { ValidationModule } from 'app/validation';
import { DropzoneConfigInterface, DropzoneModule, DROPZONE_CONFIG } from 'ngx-dropzone-wrapper';
import { SelectsModule } from '../selects/selects.module';
import { SmartadminValidationModule } from '../forms/validation/smartadmin-validation.module';
import { SmartadminModule } from '../smartadmin.module';
import { DistributeDeliveryComponent } from '../distribute-delivery/distribute-delivery.component';
import { JobsToBeDoneComponent } from '../jobs-to-be-done/jobs-to-be-done.component';
import { ContributionsComponent } from '../contributions/contributions.component';
import { EditReasonComponent } from '../edit-reason/edit-reason.component';
import { CreateTacticModule } from '../create-new-tactic/create-campaign-new-tactic.module';
import { CreateNewTacticComponent } from '../create-new-tactic/create-campaign-new-tactic.component';
import { FundingSourcesModalComponent } from '../funding-sources-modal/funding-sources-modal.component';
import { ExpensesMindShareComponent } from '../expenses-modal/expenses-mindshare-modal.component';
import { NewCommunicationRequestComponent } from '../new-communication-request/new-communication-request.component';
import { CommunicationRequestDetailsComponent } from '../communication-request-details/communication-request-details.component';
import { CreateCampaignCartModalComponent } from '../campaign-cart-modal/campaign-cart-modal.component';
import { RetailerProfileApprovalRequestComponent } from '../retailer-profile-approval-request/retailer-profile-approval-request.component';
import { NewProfileVersionComponent } from '../retailer-profile-new-version/retailer-profile-new-version.component';
import { AddressBookDeliveryInformationComponent } from '../addressbook-delivery-information/addressbook-delivery-information.component';

const DEFAULT_DROPZONE_CONFIG: DropzoneConfigInterface = {
  // Change this to your upload POST address:
   url: 'https://httpbin.org/post',
   maxFilesize: 50,
   acceptedFiles: 'csv/*'
 };
@NgModule({
  imports: [
    CommonModule,
    HeaderModule,
    NavigationModule,
    FormsModule,
    RouterModule,
    UtilsModule,
    TooltipModule,
    BsDropdownModule,
    DirectivesModule,
    PipesModule,
    AppTypeaheadModule,
    BsDatepickerModule.forRoot(),
    ValidationModule,
    DropzoneModule,
    SelectsModule,
    SmartadminValidationModule,
    ReactiveFormsModule,
    SharedComponentsModule
  ],
  declarations: [
    FooterComponent,
    RibbonComponent,
    ShortcutComponent,
    LayoutSwitcherComponent,
    MainLayoutComponent,
    EmptyLayoutComponent,
    AuthLayoutComponent,
    RouteBreadcrumbsComponent,
    CampaignGridAssetsComponent,
    CampaignGridTacticsComponent,
    CampaignImagePreviewModalComponent,
    CampaignModalComponent,
    CreateCampaignModalComponent,
    DeliveryInformationComponent,
    DistributeDeliveryComponent,
    JobsToBeDoneComponent,
    ContributionsComponent,
    EditReasonComponent,
    CreateNewTacticComponent,
    FundingSourcesModalComponent,
    ExpensesMindShareComponent,
    NewCommunicationRequestComponent,
    CommunicationRequestDetailsComponent,
    CreateCampaignCartModalComponent,
    NewProfileVersionComponent,
    RetailerProfileApprovalRequestComponent,
    AddressBookDeliveryInformationComponent
  ],
  exports: [
    HeaderModule,
    NavigationModule,
    FooterComponent,
    RibbonComponent,
    ShortcutComponent,
    LayoutSwitcherComponent,
    DeliveryInformationComponent,
    CreateCampaignModalComponent,
    NewProfileVersionComponent,
    RetailerProfileApprovalRequestComponent,
    AddressBookDeliveryInformationComponent
  ],
  providers: [
    {
      provide: DROPZONE_CONFIG,
      useValue: DEFAULT_DROPZONE_CONFIG
    }
  ]
})
export class SmartadminLayoutModule{

}



// WEBPACK FOOTER //
// ./src/app/shared/layout/layout.module.ts